import Box from "@material-ui/core/esm/Box";
import IconButton from "@material-ui/core/esm/IconButton";
import Tooltip from "@material-ui/core/esm/Tooltip";
import { nanoid } from 'nanoid';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadButton } from 'components/Button';
import { SearchBar, FormElement } from 'components/Form';
import CheckboxComponent from 'components/Form/Checkbox';
import { Title } from 'components/Text';
import { agreementOverviewDownloadUrl } from 'constants/urls';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import downloadBlob from 'utils/download/downloadBlob';
import isNorwegian from 'utils/language/isNorwegian';
import useStyles from '../Agreements/AgreementStyles';
import AgreementsList from './AgreementsList/AgreementsList';
import GetStarted from './GetStarted';
import InfoOutlined from "@material-ui/icons/esm/InfoOutlined";
const idSuffix = nanoid();
export default function Agreements() {
  const {
    t,
    i18n
  } = useTranslation();
  const {
    customer,
    loading
  } = useCurrentCustomer();
  const [searchTerm, setSearchTerm] = useState('');
  const [showClosedAgreements, setShowClosedAgreements] = useState(false);
  const [showTerminatedObes, setShowTerminatedObes] = useState(false);
  const {
    tooltipText
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GetStarted, null), /*#__PURE__*/React.createElement(Title, null, t('titles.agreements')), /*#__PURE__*/React.createElement(FormElement, {
    title: t('agreements.agreement_details.search'),
    childId: `agreementSearch_${idSuffix}`
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, t('agreements.agreement_details.search_subtitle')), /*#__PURE__*/React.createElement(SearchBar, {
    placeholder: t('vehicles.search'),
    onChange: setSearchTerm,
    id: `agreementSearch_${idSuffix}`
  })), /*#__PURE__*/React.createElement(CheckboxComponent, {
    label: t('agreements.agreement_details.show_closed_agreements'),
    name: "show_terminated_agreements",
    checked: showClosedAgreements,
    setChecked: setShowClosedAgreements
  }), /*#__PURE__*/React.createElement(CheckboxComponent, {
    label: t('agreements.agreement_details.show_terminated_obes'),
    name: "show_terminated_obes",
    checked: showTerminatedObes,
    setChecked: setShowTerminatedObes
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(DownloadButton, {
    disabled: !customer?.id || loading,
    onClick: () => {
      if (!customer?.id) return;
      downloadBlob(agreementOverviewDownloadUrl(customer.id, isNorwegian(i18n) ? 'no' : 'eng'), 'Agreement-overview');
    }
  }, t('agreements.download_overview')), /*#__PURE__*/React.createElement(Tooltip, {
    title: t('agreements.overview_helper_text') || '',
    classes: {
      tooltip: tooltipText
    }
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(InfoOutlined, null)))), /*#__PURE__*/React.createElement(AgreementsList, {
    search: searchTerm,
    showTerminatedObes: showTerminatedObes,
    showClosedAgreements: showClosedAgreements
  }));
}